import { getHeight, getSpacing, getWidth } from '@cabonline/ui-shared';
import styled from '@emotion/styled';
import bgImage from '../../../assets/drivers-bg.webp';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

export const StyledWelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: ${getSpacing('m')};
  min-width: 50vw;
  min-height: 60vh;
`;

export const StyledWelcomeText = styled.div`
  max-width: ${getWidth('form')};
`;

export const StyledRight = styled.div`
  flex: 1;
  background-image: url(${bgImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  min-height: calc(100vh - ${getHeight('navHeightDesktop')});
`;
